<div class="container">
  <div class="header">
    <glxy-infinite-scroll-trigger
      class="host-visibility-container"
      [visiblilityMargin]="0"
      (isVisible)="columnVisible.emit()"
      (isHidden)="columnHidden.emit()"
    ></glxy-infinite-scroll-trigger>
    <ng-container
      [ngTemplateOutlet]="headerTemplate ?? defaultHeaderTemplate"
      [ngTemplateOutletContext]="{ $implicit: column, metadata: metadata$ | async }"
    ></ng-container>
  </div>
  <div
    class="content"
    [class.content--dropping]="isDroppingTarget"
    cdkDropList
    [cdkDropListData]="column"
    cdkDropListSortingDisabled
    [cdkDropListEnterPredicate]="canDropItem.bind(this)"
    (cdkDropListEntered)="dropItemEntered()"
    (cdkDropListExited)="dropItemExited()"
    (cdkDropListDropped)="dropItemDropped($event)"
  >
    @for (item of items$ | async; track $index) {
      <crm-board-card
        cdkDrag
        [cdkDragData]="item"
        [item]="item"
        [cardTemplate]="cardTemplate"
        (clicked)="handleCardClickEvent(item)"
      >
        <div *cdkDragPlaceholder class="item--dragging"></div>
      </crm-board-card>
    }
    @if ((loading$$ | async) === false) {
      <glxy-infinite-scroll-trigger
        [visiblilityMargin]="40"
        (isVisible)="scrollAreaVisible()"
      ></glxy-infinite-scroll-trigger>
    } @else {
      <div>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</div>

<ng-template #defaultHeaderTemplate let-column>
  <div class="default-header">{{ column.name }}</div>
</ng-template>
